import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { V3AppsContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

const useWorkspaceAndItemFromRoute = () => {
  const { availableWorkspaces } = useContext(V3AppsContext);
  const { workspaceSlug, itemKey } = useParams<{
    workspaceSlug: string;
    itemKey?: string;
  }>();

  const selectedWorkspace = useMemo(() => {
    return availableWorkspaces.find((p) => p.urlSlug === workspaceSlug);
  }, [availableWorkspaces, workspaceSlug]);

  const selectedItem = useMemo(() => {
    if (!itemKey || !selectedWorkspace) {
      return undefined;
    }

    let item: V3.Navigation.Item | undefined;
    selectedWorkspace.navigationSettings.sections.forEach((section) => {
      section.items.forEach((i) => {
        if (itemKey === i.key) {
          return (item = i);
        }
      });
    });

    return item;
  }, [itemKey, selectedWorkspace]);

  const selectedSection = useMemo(() => {
    if (!selectedItem || !selectedWorkspace) {
      return undefined;
    }

    return selectedWorkspace.navigationSettings.sections.find((section) =>
      section.items.some((i) => i.key === selectedItem.key),
    );
  }, [selectedItem, selectedWorkspace]);

  return {
    selectedWorkspace,
    selectedItem,
    selectedSection,
  };
};

export default useWorkspaceAndItemFromRoute;
